export default {
  // websocket地址
  // websocketUrl : 'wss://localhost:12656',
  // websocketUrl : 'wss://127.0.0.1:12656',
  // websocketUrl : 'ws://localhost:1112',
  // 在IE下，使用localhost主机时，会导致出现SCRIPT5022: SecurityError错误，使用127.0.0.1以避免;
  websocketUrl: 'ws://127.0.0.1:1112',

  // SDK持续时间
  sdkDuration: 3600 * 24,
  // 系统码
  sysCode: '36363636',
  // 锁匠码
  regCode: '31313131',
  // 操作后是否声音提示
  beepAfterOperations: true,
  // 读取数据后是否清空
  clearAfterRead: true,
  // 支持的接口
  supportedInterfaces: [
    'readkey',
    'readkeyevent',
    'registerkey',
    'logoutkey',
    'createblankkey',
    'createuserkey', // 设置开锁钥匙
    'createregisterkey', // 设置锁的系统码的钥匙
    'createsettingkey', // 修改锁的id/groupid的钥匙
    'createauditkey', // 读取开锁成功事件的钥匙
    'createverifykey', // 读取锁的id/groupid的钥匙
    'createtracekey', // 读取锁的硬件编号的钥匙
    'createemergencykey', // 应急钥匙随意开锁
    'createlogoutkey', // 清空锁内信息恢复出厂设置
    'createblacklistkey', // 设置黑名单钥匙
  ],
};
